import React from 'react';
import { Radio, RadioChangeEvent } from 'antd';

import { Book } from './Book/Book';

import styles from './AddElection.module.scss';

const BookElectionList = ({ onChange, booksSearchResults }) => {
  const onChangeBook = async (e: RadioChangeEvent) => {
    e.preventDefault()

    const selectedBook = JSON.parse(e.target.value)

    onChange(selectedBook)
  }

  if (!booksSearchResults.length) return null

  return (
    <Radio.Group
      onChange={onChangeBook}
      className={styles.list}>
      {(booksSearchResults as Array<any> || []).map((book, index) =>
        <Radio key={index} value={JSON.stringify(book)}>
          <Book book={book} />
        </Radio>
      )}
    </Radio.Group>
  )
}

export default BookElectionList;